import { render, staticRenderFns } from "./spu.vue?vue&type=template&id=4217f872&scoped=true"
import script from "./spu.vue?vue&type=script&lang=js"
export * from "./spu.vue?vue&type=script&lang=js"
import style0 from "./spu.vue?vue&type=style&index=0&id=4217f872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4217f872",
  null
  
)

export default component.exports